import React, { memo } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import DropZone from './DropZone/DropZone';

const FormGroupDropZone = ({
    name,
    notice,
    maxFileSizeMB,
    columnGridCount,
    contentBase64Encoded,
    ...restProps
}) => (
    <Field
        {...restProps}
        component={DropZone}
        name={name}
        props={{
            notice,
            maxFileSizeMB,
            columnGridCount,
            contentBase64Encoded,
        }}
    />
);

FormGroupDropZone.defaultProps = {
    notice: null,
    columnGridCount: 24,
    contentBase64Encoded: true,
};

FormGroupDropZone.propTypes = {
    name: PropTypes.string.isRequired,
    notice: PropTypes.string,
    maxFileSizeMB: PropTypes.number.isRequired,
    contentBase64Encoded: PropTypes.bool,
    columnGridCount: PropTypes.number,
};

export default memo(FormGroupDropZone);
